import Vue from 'vue';
import { currencyFormat, formatDate, formatCardMask } from '@/utils';

Vue.filter('capitalize', (value: string): string => {
  if (!value) { return ''; }
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
});

Vue.filter('plural', (msg: string, value: string, counter: number): string => {
  if (!msg) { return ''; }
  return counter > 1 ? value : msg;
});

Vue.filter('removeSlug', (value: string): string => {
  if (!value) { return ''; }
  return value.split('-')[0];
});

Vue.filter('currencyFormat', (value: number): string => {
  return currencyFormat(value);
});

Vue.filter('formatDate', (value: string): string => {
  return formatDate(value);
});

Vue.filter('formatCardMask', (value: string): string => {
  return formatCardMask(value);
});
